<template>
  <div v-if="invoice" class="d-lg-none d-block">
    <div>
      <div class="col-6 col-md-4 col-lg-4 mb-4">
        <div class="invoice-logo">
          <img
            v-if="invoice?.user?.setting"
            :src="invoice?.user?.setting?.business_logo"
            alt="logo"
          />
          <img
            v-else-if="settings?.business_logo"
            :src="settings?.business_logo"
            alt="logo"
          />
        </div>
        <router-link
          v-if="invoice?.user?.setting === null && settings?.business_logo === null"
          class="btn btn-primary upload-logo"
          to="/invoice/settings"
          ><i class="feather feather-upload me-2" aria-hidden="true"></i>Upload
          Business logo</router-link
        >
      </div>
      <div class="col-md-8 col-lg-8 mt-2">
        <h1 class="invoice_mb-head mb-1">
          {{ invoice?.invoice_id }}
        </h1>
        <p class="total-inner-p">
          {{ invoice?.description }}
        </p>
      </div>
    </div>

    <div class="py-3 my-3 border border-start-0 border-end-0">
      <div class="invoice_mb-to">
        <p class="invoice-details-two text-start">
          Status:
          <span
            class="invoice-status text-success"
            v-if="
							invoice.status === 'paid' ||
							invoice.status === 'refunded' ||
							invoice.status === 'sent' ||
							invoice.status === 'viewed' ||
							invoice.status === 'accepted'
						"
            >{{ invoice.status }}</span
          >
          <span
            class="invoice-status text-warning"
            v-else-if="
							invoice.status === 'draft' ||
							invoice.status === 'pending' ||
							invoice.status === 'unpaid' ||
							invoice.status === 'recurring'
						"
            >{{ invoice.status }}</span
          >
          <span
            class="invoice-status text-warning"
            v-else-if="invoice.status === 'partially_paid'"
            >Partially paid</span
          >
          <span
            class="invoice-status text-danger"
            v-else-if="
							invoice.status === 'expired' ||
							invoice.status === 'rejected' ||
							invoice.status === 'refunded' ||
							invoice.status === 'overdue'
						"
            >{{ invoice.status }}</span
          >
        </p>
        <p class="invoice-details-two text-start">
          Date:
          <strong v-if="invoice.date">{{
						formatDateToDigits(invoice?.date)
          }}</strong>
        </p>
        <p class="invoice-details-two text-start">
          Due on:
          <strong v-if="invoice.due_date">{{
						formatDateToDigits(invoice?.due_date)
          }}</strong>
        </p>
        <p class="invoice-details-two text-start">
          Amount:
          <strong
            >{{ invoice?.currency?.slice(0, 3) }}
            {{ addCurrencyComma(invoice?.total_amount) }}</strong
          >
        </p>
      </div>
      <div v-if="invoice?.user" class="invoice_mb-to my-4">
        <p class="customer_mb-text-one text-start">Invoice From:</p>
        <p class="invoice-details-two">
          {{ invoice?.user?.name }}
        </p>
        <p class="invoice-details-two">
          {{ invoice?.user?.email }}
        </p>
        <p class="invoice-details-two">
          {{ invoice?.user?.phone }}
        </p>
        <p class="invoice-details-two">
          {{ invoice?.user?.address }}
        </p>
        <p class="invoice-details-two">
          {{ invoice?.user?.state }} {{ invoice?.user?.country }}
        </p>
      </div>
      <div v-else class="invoice_mb-to my-4">
        <p class="customer_mb-text-one text-start">Invoice From:</p>
        <p class="invoice-details-two">
          {{ user?.name }}
        </p>
        <p class="invoice-details-two">
          {{ user?.email }}
        </p>
        <p class="invoice-details-two">
          {{ user?.phone }}
        </p>
        <p class="invoice-details-two">
          {{ invoice?.user?.address }}
        </p>
        <p class="invoice-details-two">{{ user?.state }} {{ user?.country }}</p>
      </div>
      <div class="invoice_mb-to">
        <p class="customer_mb-text-one">Invoice To:</p>
        <p class="invoice-details-two">
          {{ invoice?.customer?.name }}<br />
          {{ invoice?.customer?.email }}<br />
          {{`${invoice?.customer?.country_code} ${invoice?.customer?.phone}`






          }}<br />
          {{ invoice?.customer?.address }}<br />

          {{ invoice?.customer?.state }} {{ invoice?.customer?.country }}
        </p>
      </div>
    </div>

    <div class="card-body m-0">
      <!-- Invoice Item -->
      <div class="invoice-item">
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive2">
              <table class="table table-center table-hover mb-0">
                <thead class="thead-light">
                  <tr>
                    <th class="table-data">#</th>
                    <th class="table-data">Product / Service</th>
                    <th class="table-data">Quantity</th>
                    <th class="table-data">Price</th>
                    <th class="table-data">Discount</th>
                    <th class="text-end table-data">Amount</th>
                  </tr>
                </thead>
                <tbody v-if="invoice.items">
                  <tr v-for="(item, index) in invoice.items" :key="index">
                    <td class="table-data">
                      {{ index + 1 }}
                    </td>
                    <td class="table-data">{{ item.name }}</td>
                    <td class="table-data">
                      {{ item.quantity }}
                    </td>
                    <td class="table-data">
                      {{ invoice?.currency?.slice(0, 3) }}
                      {{ addCurrencyComma(item.price) }}
                    </td>
                    <td class="table-data">{{ item.discount }}%</td>
                    <td class="text-end table-data">
                      {{ invoice?.currency?.slice(0, 3) }}
                      {{ addCurrencyComma(item.amount) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- /Invoice Item -->
    </div>

    <!-- Terms & Conditions -->
    <div class="row justify-content-end my-3">
      <div>
        <div class="invoice-total-card">
          <div class="invoice-total-box">
            <div class="invoice-total-inner">
              <p class="total-inner-p">
                Taxable Amount
                <span
                  >{{ invoice?.currency?.slice(0, 3) }}
                  {{ addCurrencyComma(invoice.amount) }}</span
                >
              </p>
              <p class="total-inner-p">
                Discount<span
                  >{{ invoice?.currency?.slice(0, 3) }}
                  {{ addCurrencyComma(totalProductDiscount) }}</span
                >
              </p>
              <p v-if="invoice?.tax_enabled === 1">
                {{ `VAT(${invoice.tax_percentage}%)` }}
                <span
                  >{{ invoice?.currency?.slice(0, 3) }}
                  {{ addCurrencyComma(vat) }}</span
                >
              </p>
              <p
                class="total-inner-p"
                v-for="(discount, index) in invoice?.more_discount"
                :key="index"
              >
                {{ discount.description }}
                <span
                  >- {{ invoice?.currency?.slice(0, 3) }}
                  {{ addCurrencyComma(discount.value) }}</span
                >
              </p>
              <p
                class="total-inner-p"
                v-for="(charge, index) in invoice?.additional_charges"
                :key="index"
              >
                {{ charge.description }}
                <span
                  >+ {{ invoice?.currency?.slice(0, 3) }}
                  {{ addCurrencyComma(charge.value) }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Total -->
    <div class="border border-start-0 border-end-0 py-3">
      <div style="display: flex; justify-content: space-between">
        <div style="width: 47.8%">
          <div class="invoice-total-card">
            <div class="invoice-total-box">
              <div class="invoice-total-footer">
                <h4 class="total-amount" style="font-size: 20px">
                  Total Amount
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="invoice-total-box">
          <div class="invoice-total-footer" style="margin-top: 0">
            <h4 class="total-amount" style="font-size: 20px; margin-top: 0">
              {{ invoice?.currency?.slice(0, 3) }}
              {{ addCurrencyComma(invoice?.total_amount) }}
            </h4>
          </div>
        </div>
      </div>
      <div>
        <p class="total-inner-p">
          Total Items :
          {{ invoice?.items?.length }}
        </p>
      </div>
    </div>

    <!-- Total -->
    <div
      v-if="invoice.amount_paid != 0"
      class="border border-start-0 border-top-0 border-end-0 pt-3"
    >
      <div style="display: flex; justify-content: space-between">
        <div style="width: 47.8%">
          <div class="invoice-total-card">
            <div class="invoice-total-box">
              <div class="invoice-total-footer">
                <h4 class="total-amount" style="font-size: 16px">
                  Amount Paid
                </h4>
                <h4 class="total-amount pt-2" style="font-size: 16px">
                  Balance
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="invoice-total-box">
          <div class="invoice-total-footer" style="margin-top: 0">
            <h4 class="total-amount" style="font-size: 16px; margin-top: 0">
              {{ invoice?.currency?.slice(0, 3) }}
              {{ invoice?.amount_paid }}
            </h4>
            <h4 class="total-amount pt-2" style="font-size: 16px">
              {{ invoice?.currency?.slice(0, 3) }}
              {{ addCurrencyComma(invoice?.amount_due) }}
            </h4>
          </div>
        </div>
      </div>
    </div>

    <!-- Total -->
    <div style="display: flex; justify-content: start" class="my-3">
      <p class="total-inner-p">
        Total Amount (in words):
        <span
          style="margin-left: 2px; color: black; text-transform: capitalize"
          v-if="invoice?.total_amount"
        >
          {{ amountToWords(invoice?.total_amount, invoice?.currency) }}</span
        >
      </p>
    </div>

    <!-- Bank Details and Signature-->
    <div
      class="d-flex justify-content-between border border-start-0 border-end-0 py-3"
    >
      <div>
        <div
          v-if="invoice?.user?.setting?.preferred_bank_id"
          style="margin-right: 25px"
        >
          <h1 class="bank-title total-amount">
            Bank Information
          </h1>
          <div class="total-inner-p">
            Bank's Name:
            <p class="text-black">
              {{ invoice.preferred_bank?.bank_name }}
            </p>
          </div>
          <div class="total-inner-p">
            Account Number:
            <p class="text-black">
              {{ invoice.preferred_bank?.account_number }}
            </p>
          </div>
          <div class="total-inner-p">
            Account Name:
            <p class="text-black">
              {{ invoice.preferred_bank?.account_name }}
            </p>
          </div>
        </div>
        <div v-else-if="preferred_bank?.id" style="margin-right: 25px">
          <div class="total-inner-p">
            Bank's Name:
            <p class="text-black">
              {{ preferred_bank.bank_name }}
            </p>
          </div>
          <div class="total-inner-p">
            Account Number:
            <p class="text-black">
              {{ preferred_bank.account_number }}
            </p>
          </div>
          <div class="total-inner-p">
            Account Name:
            <p class="text-black">
              {{ preferred_bank.account_name }}
            </p>
          </div>
        </div>
      </div>
      <div v-if="invoice?.user?.setting">
        <div class="text-end" v-if="invoice?.signature !== null">
          <p class="total-inner-p" style="color: black; margin-bottom: 8px">
            {{ invoice?.signatory_name }}
          </p>
          <img
            style="max-width: 150px"
            :src="invoice?.signature"
            alt="Signature"
          />
        </div>
        <div
          class="text-end"
          v-if="
						invoice?.signature == null &&
						invoice?.user?.setting?.signature != null
					"
        >
          <p class="total-inner-p" style="color: black; margin-bottom: 8px">
            {{ invoice?.user?.setting?.signatory_name }}
          </p>
          <img
            style="max-width: 150px"
            :src="invoice?.user?.setting?.signature"
            alt="Signature"
          />
        </div>
      </div>
      <div v-else>
        <div class="text-end" v-if="invoice?.signature !== null">
          <p class="total-inner-p" style="color: black; margin-bottom: 8px">
            {{ invoice?.signatory_name }}
          </p>
          <img
            style="max-width: 150px"
            :src="invoice?.signature"
            alt="Signature"
          />
        </div>
        <div
          class="text-end"
          v-if="invoice?.signature == null && settings?.signature != null"
        >
          <p class="total-inner-p" style="color: black; margin-bottom: 8px">
            {{ settings?.signatory_name }}
          </p>
          <img
            style="max-width: 150px"
            :src="settings?.signature"
            alt="Signature"
          />
        </div>
      </div>
    </div>

    <!-- Terms and Conditions -->
    <div
      v-if="invoice?.terms"
      class="d-flex border border-start-0 border-top-0 border-end-0 py-3"
    >
      <div class="text-start">
        <p class="bank-title total-amount">Terms and Conditions</p>
        <div class="total-inner-e" v-html="invoice.terms"></div>
      </div>
    </div>

    <!-- Note -->
    <div class="total-amount py-3">
      <div>
        <div>
          <div class="text-start">
            <p class="bank-title total-amount">Notes</p>
            <div class="total-inner-e" v-html="invoice.notes"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
	addCurrencyComma,
	amountToWords,
} from "@/assets/composables/currency";
import { formatDateToDigits } from "@/assets/composables/date";

const props = defineProps({
	invoice: {
		type: Object,
	},
	user: {
		type: Object,
	},
	preferred_bank: {
		type: Object,
	},
	totalAmount: {
		type: Number,
	},
	taxableAmount: {
		type: Number,
	},
	totalProductDiscount: {
		type: Number,
	},
	vat: {
		type: Number,
	},
	tax_percentage: {
		type: Number,
	},
	settings: {
		type: Object,
	},
});
</script>

<style>
@media (max-width: 960px) {
	.d-invoice {
		display: none;
	}
}
.invoice_mb-head {
	font-size: 18px;
}
.customer_mb-text-one {
	color: #95979b;
	display: block;
	margin: 0 0 8px;
}
.invoice_mb-to .invoice-details-two {
	text-align: left;
	font-size: 14px;
	color: #2c3038;
}
</style>
